import { render, staticRenderFns } from "./PushNotificationsPage.vue?vue&type=template&id=5a3e24ae&"
import script from "./PushNotificationsPage.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports